module.exports = __webpack_public_path__ + "img/13.95e9ff99.png";